interface AirportFilters {
  originAirportCodes: Array<string>
  destinationAirportCodes: Array<string>
}

/**
 * Narrows flight deals down to the origin and destination airports configured in Contentful.
 * An empty list means that side of the route is not restricted.
 */
export function filterFlightDealsByAirports<T extends Pick<App.FlightDeal, 'originAirportCode' | 'destinationAirportCode'>>(
  flightDeals: Array<T>,
  { originAirportCodes, destinationAirportCodes }: AirportFilters,
): Array<T> {
  const origins = new Set(originAirportCodes)
  const destinations = new Set(destinationAirportCodes)

  return flightDeals.filter(deal =>
    (origins.size === 0 || origins.has(deal.originAirportCode)) &&
    (destinations.size === 0 || destinations.has(deal.destinationAirportCode)),
  )
}
